const brand = {
  name: 'Samurai Pay',
  desc: 'Dandelion Pro - React Website Template',
  prefix: 'dandelion',
  footerText: 'Dandelion Pro All Rights Reserved 2018',
  logoText: 'Dandelion Pro',
};

export default brand;